import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../../../../../Modal/Store';
import IframeContentStore from '../IframeContent/Store';
import PreviewStore from '../Store';
import { isInEditMode } from '../Store/Types';
import LearningCollectionForm from './LearningCollectionForm';

interface Props {
  store: PreviewStore;
  iframeContentStore: IframeContentStore;
  learningCollectionDescriptionModalStore: ModalStore;
}

const SideBar: React.FC<Props> = ({
  store,
  iframeContentStore,
  learningCollectionDescriptionModalStore,
}) => {
  return (
    <div
      className={clsx(
        'relative transition-all duration-500 ease-in ',
        store.inEditMode ? 'lg:w-[25%]' : 'w-0',
      )}
    >
      {when(isInEditMode, store)
        .map(() => (
          <LearningCollectionForm
            store={store}
            iframeContentStore={iframeContentStore}
            learningCollectionDescriptionModalStore={learningCollectionDescriptionModalStore}
          />
        ))
        .getOrElse(() => (
          <></>
        ))}
    </div>
  );
};

export default observer(SideBar);
